import { Lightning } from '@lightningjs/sdk';
import { Block } from '../../../block/block.component';
import { templates } from './list.constants';

export class List extends Lightning.Component {
  static _template() {
    return {
      Block: {
        type: Block,
      },
    };
  }

  static getOffsetsByBlockData(data) {
    return Block.getOffsetsByBlockData(data);
  }

  _detach() {
    this._data = undefined;
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
    this.patch({
      ...value.rowSize,
      Block: {
        data: value,
      },
    });
  }

  get contentPadding() {
    return this.tag('Block').contentPadding;
  }

  set contentPadding(value) {
    this.tag('Block').contentPadding = value;
  }

  get focusMode() {
    return this.tag('Block').focusMode;
  }

  set focusMode(value) {
    this.tag('Block').focusMode = value;
  }

  get contentGap() {
    return this.tag('Block').contentGap;
  }

  set contentGap(value) {
    this.tag('Block').contentGap = value;
  }

  get focusedIndex() {
    return this.tag('Block').focusedIndex;
  }

  set focusedIndex(value) {
    this.tag('Block').focusedIndex = value;
  }

  goTo(index) {
    this.tag('Block').goTo(index);
  }

  _getFocused() {
    return this.tag('Block');
  }
}

List.Templates = templates;
